<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{ style: { width: '150px' } }"
    layout="inline"
    :wrapper-col="{ style: { width: '210px' } }"
  >
    <a-form-item label="电源适配器" name="acadapter">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.acadapter"
        placeholder="电源适配器"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="验收单" name="acceptanceForm">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.acceptanceForm"
        placeholder="验收单"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="A4打印机（黑白）" name="blackAndWhitePrinter">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.blackAndWhitePrinter"
        placeholder="A4打印机（黑白）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="儿童托" name="childCare">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.childCare"
        placeholder="儿童托"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="下巴托纸（含钉）" name="chinSupportPaper">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.chinSupportPaper"
        placeholder="下巴托纸（含钉）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="扫码枪" name="codeScanner">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.codeScanner"
        placeholder="扫码枪"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="A4打印机（彩色）" name="colorPrinter">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.colorPrinter"
        placeholder="A4打印机（彩色）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="防尘罩" name="dustCover">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.dustCover"
        placeholder="防尘罩"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="拓展屏（含线材）" name="expansionScreen">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.expansionScreen"
        placeholder="拓展屏（含线材）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="主机" name="host">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.host"
        placeholder="主机"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="一体机（含线材）" name="integratedMachine">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.integratedMachine"
        placeholder="一体机（含线材）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="1100*600升降台" name="largeLiftingTable">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.largeLiftingTable"
        placeholder="1100*600升降台"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="遮光罩" name="lensHood">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.lensHood"
        placeholder="遮光罩"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="售后服务承诺书" name="letterOfCommitment">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.letterOfCommitment"
        placeholder="售后服务承诺书"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="模拟眼" name="modelEye">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.modelEye"
        placeholder="模拟眼"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="显示器（含线材）" name="monitor">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.monitor"
        placeholder="显示器（含线材）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="使用说明书" name="operationInstructions">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.operationInstructions"
        placeholder="使用说明书"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="包材" name="packagingMaterials">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.packagingMaterials"
        placeholder="包材"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="包装清单" name="packingList">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.packingList"
        placeholder="包装清单"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="PC线" name="pcwire">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.pcwire"
        placeholder="PC线"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="产品合格证" name="productCertificate">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.productCertificate"
        placeholder="产品合格证"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="投影屏" name="projectionScreen">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.projectionScreen"
        placeholder="投影屏"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="700*550升降台" name="smallLiftingTable">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.smallLiftingTable"
        placeholder="700*550升降台"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="热敏打印机" name="thermalPrinter">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.thermalPrinter"
        placeholder="热敏打印机"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="运输箱（航空箱）" name="transportBox">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.transportBox"
        placeholder="运输箱（航空箱）"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="运输固定套装" name="transportFixedSet">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.transportFixedSet"
        placeholder="运输固定套装"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="保修卡" name="warrantyCard">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.warrantyCard"
        placeholder="保修卡"
        allowClear
      ></a-input-number>
    </a-form-item>
    <a-form-item label="线盒" name="wireBox">
      <a-input-number
        style="width: 210px"
        v-model:value="formState.wireBox"
        placeholder="线盒"
        allowClear
      ></a-input-number>
    </a-form-item>
  </a-form>
</template>
<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { Toast } from "@/utils";
export default defineComponent({
  props: {
    accessory: Object,
  },
  setup(props, context) {
    const formState = reactive({
      acadapter: null,
      acceptanceForm: null,
      blackAndWhitePrinter: null,
      childCare: null,
      chinSupportPaper: null,
      codeScanner: null,
      colorPrinter: null,
      dustCover: null,
      expansionScreen: null,
      host: null,
      id: null,
      integratedMachine: null,
      largeLiftingTable: null,
      lensHood: null,
      letterOfCommitment: null,
      modelEye: null,
      monitor: null,
      operationInstructions: null,
      oqcId: null,
      packagingMaterials: null,
      packingList: null,
      pcwire: null,
      productCertificate: null,
      projectionScreen: null,
      repairEquipmentId: null,
      smallLiftingTable: null,
      thermalPrinter: null,
      transportBox: null,
      transportFixedSet: null,
      warrantyCard: null,
      wireBox: null,
    });
    const rules = {
      // acadapter: [{ required: true, message: null, trigger: "change" }],
      // acceptanceForm: [{ required: true, message: null, trigger: "change" }],
      // blackAndWhitePrinter: [
      //   { required: true, message: null, trigger: "change" },
      // ],
      // childCare: [{ required: true, message: null, trigger: "change" }],
      // chinSupportPaper: [{ required: true, message: null, trigger: "change" }],
      // codeScanner: [{ required: true, message: null, trigger: "change" }],
      // colorPrinter: [{ required: true, message: null, trigger: "change" }],
      // dustCover: [{ required: true, message: null, trigger: "change" }],
      // expansionScreen: [{ required: true, message: null, trigger: "change" }],
      // host: [{ required: true, message: null, trigger: "change" }],
      // integratedMachine: [{ required: true, message: null, trigger: "change" }],
      // largeLiftingTable: [{ required: true, message: null, trigger: "change" }],
      // lensHood: [{ required: true, message: null, trigger: "change" }],
      // letterOfCommitment: [
      //   { required: true, message: null, trigger: "change" },
      // ],
      // modelEye: [{ required: true, message: null, trigger: "change" }],
      // monitor: [{ required: true, message: null, trigger: "change" }],
      // operationInstructions: [
      //   { required: true, message: null, trigger: "change" },
      // ],
      // oqcId: [{ required: true, message: null, trigger: "change" }],
      // packagingMaterials: [
      //   { required: true, message: null, trigger: "change" },
      // ],
      // packingList: [{ required: true, message: null, trigger: "change" }],
      // pcwire: [{ required: true, message: null, trigger: "change" }],
      // productCertificate: [
      //   { required: true, message: null, trigger: "change" },
      // ],
      // projectionScreen: [{ required: true, message: null, trigger: "change" }],
      // repairEquipmentId: [{ required: true, message: null, trigger: "change" }],
      // smallLiftingTable: [{ required: true, message: null, trigger: "change" }],
      // thermalPrinter: [{ required: true, message: null, trigger: "change" }],
      // transportBox: [{ required: true, message: null, trigger: "change" }],
      // transportFixedSet: [{ required: true, message: null, trigger: "change" }],
      // warrantyCard: [{ required: true, message: null, trigger: "change" }],
      // wireBox: [{ required: true, message: null, trigger: "change" }],
    };
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const showModal = (type, options) => {
      const { title, data } = options;
      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
      if (type === "insert") {
      }
      modalConfig.title = title;
      modalConfig.visible = true;
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validateFields()
        .then((res) => {
          updateSwanAccessory(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    const resetAccessory = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
    };

    const setAccessory = (data) => {
      Object.keys(data).forEach((key) => {
        formState[key] = data[key];
      });
    };

    const getSwanAccessory = () => {
      return JSON.parse(JSON.stringify(formState));
    };

    watch(
      () => props.accessory,
      (val) => {
        resetAccessory();
        if (val) {
          setAccessory(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      formState,
      rules,
      getSwanAccessory,
      showModal,
      handleCancel,
      handleOk,
      modalConfig,
    };
  },
});
</script>
    